import React, { ReactNode } from 'react';
import { useLocation } from '@reach/router';

interface RenderOnHomeProps {
  children: ReactNode;
}

const RenderOnHome: React.FC<RenderOnHomeProps> = ({ children }) => {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  if (!isHome) return null;

  return <>{children}</>;
};

export default RenderOnHome;